/**
 * Presença do softphone: no computador o Device continua válido em segundo plano.
 * No celular (PWA/iOS/Android estreito) o WebRTC morre ao ir para background.
 */

export function detectDeviceClass(env = typeof window !== "undefined" ? window : null) {
  if (!env) return "desktop";
  try {
    const nav = env.navigator || {};
    const ua = String(nav.userAgent || "");
    const iOS =
      /iPad|iPhone|iPod/i.test(ua) ||
      (nav.platform === "MacIntel" && Number(nav.maxTouchPoints || 0) > 1);
    const androidPhone = /Android/i.test(ua) && /Mobile/i.test(ua);
    const narrow =
      typeof env.matchMedia === "function" && env.matchMedia("(max-width: 768px)").matches;
    if (iOS || androidPhone || narrow) return "mobile_pwa";
  } catch (_) {
    /* ignore */
  }
  return "desktop";
}

export function isComputerSoftphone(deviceClass = detectDeviceClass()) {
  return String(deviceClass || "desktop") !== "mobile_pwa";
}

/**
 * Pronto para o backend discar o Client.
 * Desktop / Chrome App / várias janelas: Device registrado basta.
 * Celular: só com aba visível.
 */
export function shouldReportSoftphoneReady({
  hasRegisteredDevice = false,
  visibilityState = "visible",
  deviceClass = "desktop",
} = {}) {
  if (!hasRegisteredDevice) return false;
  if (!isComputerSoftphone(deviceClass)) {
    return String(visibilityState || "") !== "hidden";
  }
  return true;
}
